if (!customElements.get('product-specs-modal')) {
  customElements.define(
    'product-specs-modal',
    class ProductSpecsModal extends ModalWindow {
      constructor() {
        super();
      }

      show(opener) {
        this.opener = opener;
        window.pauseAllMedia();
        this.style.display = 'block';
        this.classList.add('modal-show');

        lazyLoadInstance?.update();

        setTimeout(() => {
          document.body.style.overflow = 'hidden';
          this.classList.add('modal-visuallyshow');
        }, 300);

        // Add focus trapping after the modal is shown
        requestAnimationFrame(() => {
          trapFocus(this);
        });
      }
    }
  );
}